import React, { useContext } from 'react';

const AuthContext = React.createContext();
export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;

export const initialAuthState = {
  access_token: null,
  user: null,
};

export const withAuth = (Component) => {
  return (props) => (
    <AuthConsumer>
      {({ auth, setAuth }) => (
        <Component
          auth={auth}
          setAuth={setAuth}
          {...props}
        />
      )}
    </AuthConsumer>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
